import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { Grid } from '../../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../CommonComponents/OPL/Grid/Column';

export interface BillingAddressFields {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  email: string;
  phone: string;
}

interface BillingAddressProps {
  formBag: UseFormReturn<BillingAddressFields>;
}

export const BillingAddress: React.FC<BillingAddressProps> = ({
  formBag: {
    register,
    formState: { errors },
  },
}) => {
  return (
    <>
      <Box display="flex" alignItems="center" mt="16">
        <Text fontWeight={600}>Billing Address</Text>
      </Box>

      <Grid>
        <Row mt="16">
          <Column width={6}>
            <Input
              {...register('firstName')}
              name="firstName"
              label="First Name"
              type="text"
              placeholder="First Name"
              formVariant={errors.firstName ? 'error' : undefined}
              helperText={errors.firstName?.message}
              autoComplete="given-name"
            />
          </Column>

          <Column width={6}>
            <Input
              {...register('lastName')}
              label="Last Name"
              type="text"
              placeholder="Last Name"
              formVariant={errors.lastName ? 'error' : undefined}
              helperText={errors.lastName?.message}
              autoComplete="family-name"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('address1')}
              label="Address 1"
              type="text"
              placeholder="Street Address"
              formVariant={errors.address1 ? 'error' : undefined}
              helperText={errors.address1?.message}
              autoComplete="address-line1"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('address2')}
              label="Address 2"
              type="text"
              placeholder="Apt, Suite, Floor, etc"
              formVariant={errors.address2 ? 'error' : undefined}
              helperText={errors.address2?.message}
              autoComplete="address-line2"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('city')}
              label="City"
              type="text"
              placeholder="City"
              formVariant={errors.city ? 'error' : undefined}
              helperText={errors.city?.message}
              autoComplete="address-level2"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={6}>
            <Input
              {...register('country')}
              label="Country"
              type="text"
              placeholder="Country"
              formVariant={errors.country ? 'error' : undefined}
              helperText={errors.country?.message}
              autoComplete="country-name"
            />
          </Column>

          <Column width={3}>
            <Input
              {...register('state')}
              label="State"
              type="text"
              placeholder="State"
              formVariant={errors.state ? 'error' : undefined}
              helperText={errors.state?.message}
              autoComplete="address-level1"
            />
          </Column>

          <Column width={3}>
            <Input
              {...register('zip')}
              label="Zip"
              type="tel"
              placeholder="00000"
              formVariant={errors.zip ? 'error' : undefined}
              helperText={errors.zip?.message}
              autoComplete="postal-code"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('email')}
              label="Email Address"
              type="text"
              placeholder="Email"
              formVariant={errors.email ? 'error' : undefined}
              helperText={errors.email?.message}
              autoComplete="email"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={12}>
            <Input
              {...register('phone')}
              label="Phone"
              type="tel"
              placeholder="(555)555-5555"
              formVariant={errors.phone ? 'error' : undefined}
              helperText={errors.phone?.message}
              autoComplete="tel"
            />
          </Column>
        </Row>
      </Grid>
    </>
  );
};
